import { render, staticRenderFns } from "./SectionButton.vue?vue&type=template&id=4291b97c&"
import script from "./SectionButton.vue?vue&type=script&lang=js&"
export * from "./SectionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports